import {DocumentManager} from "../PDFManager/DocumentManager";
import {Dialog} from "shared/controls/Dialogs/core/Dialog";
import {LicenseRequired} from "../../../PDFList/LicenseRequired";
import * as React from "react";

export class AddFieldManager{
    public FieldBeingAdded:string='';
    public IsDraging:boolean;
    public OriginX:number;
    public OriginY:number;
    public WidthToUse:number;
    public HeightToUse:number;
    public XToUse:number;
    public YToUse:number;
    public DragHighlight:HTMLDivElement;
    constructor(public DocumentManager:DocumentManager) {
        this.DragMove=this.DragMove.bind(this);
        this.StopAddingField=this.StopAddingField.bind(this);

    }

    StartAddition(fieldId: string) {
        this.FieldBeingAdded='';
        if(!rnImporterVar.IsPR)
        {
            Dialog.Show(<LicenseRequired Message={'Sorry this feature is only available in the full version'} URL={rnImporterVar.PurchaseURL}/>);
            return;
        }

        this.FieldBeingAdded=fieldId;

        document.body.classList.add('addingField');
        document.addEventListener('mouseup',this.StopAddingField,false);


    }

    public StopAddingField(){
        document.body.classList.remove('draggingField');
        document.body.classList.remove('addingField');
        document.removeEventListener('mouseup',this.StopAddingField);
        document.removeEventListener('mousemove',this.DragMove);


        if(this.DragHighlight!=null)
        {
            this.DragHighlight.remove();
            this.DragHighlight=null;
        }
        this.IsDraging=false;
        let position=this.ComputePosition();



        this.DocumentManager.AddField(this.FieldBeingAdded,position.x,position.y,position.width,position.height);
        this.FieldBeingAdded='';

    }

    public ComputePosition(){
        let canvasTop=this.DocumentManager.Canvas.getBoundingClientRect().y;
        let canvasLeft=this.DocumentManager.Canvas.getBoundingClientRect().x;


        let heightToUse=this.HeightToUse;
        let widthToUse=this.WidthToUse;

        if(widthToUse<10)
            widthToUse=0;

        if(heightToUse<10)
            heightToUse=0;
        return {
            x:(this.XToUse-canvasLeft)/1.4,
            y:(this.YToUse-canvasTop)/1.4,
            width:widthToUse/1.4,
            height:heightToUse/1.4
        };
    }

    public IsAddingField(){
        return this.FieldBeingAdded!='';
    }

    MaybeStartDragging(e:React.MouseEvent) {
        if(!this.IsAddingField())
            return;


        document.body.classList.add('draggingField');
        this.OriginX=e.pageX+window.scrollX;
        this.OriginY=e.pageY+window.scrollY;
        this.XToUse=this.OriginX;
        this.YToUse=this.OriginY;
        this.WidthToUse=0;
        this.HeightToUse=0;
        this.IsDraging=true;
        document.addEventListener('mousemove',this.DragMove);

        if(this.DragHighlight==null)
        {
            this.DragHighlight=document.createElement('div');
            document.body.appendChild(this.DragHighlight);
            this.DragHighlight.style.display='block';
            this.DragHighlight.style.borderWidth='1px'
            this.DragHighlight.style.borderStyle='dashed';
            this.DragHighlight.style.borderColor='red';
            this.DragHighlight.style.transition='all 50ms ease-in-out';
            this.DragHighlight.style.opacity='0';
            this.DragHighlight.style.position='absolute';
            this.DragHighlight.style.zIndex='100000000';
        }


    }

    DragMove(e:MouseEvent){

        let newX=e.pageX+window.scrollX;
        let newY=e.pageY+window.scrollY;

        let upperX=Math.min(this.OriginX,newX);
        let upperY=Math.min(this.OriginY,newY);
        let bottomX=Math.max(this.OriginX,newX);
        let bottomY=Math.max(this.OriginY,newY);

        let width=bottomX-upperX;
        let height=bottomY-upperY;

        if(width>15||height>15)
            this.DragHighlight.style.opacity='1';
        else
            this.DragHighlight.style.opacity='0';

        this.DragHighlight.style.top=upperY+'px';
        this.DragHighlight.style.left=upperX+'px';
        this.DragHighlight.style.height=height+'px';
        this.DragHighlight.style.width=width+'px';

        this.XToUse=upperX;
        this.YToUse=upperY;
        this.WidthToUse=width;
        this.HeightToUse=height;





    }
}